import { createContext, useContext } from 'react';

const SelectContext = createContext(void 0);
const useSelectContext = () => {
  const context = useContext(SelectContext);
  if (context === void 0) {
    throw new Error("useSelectContext must be used within a SelectContext (which is available by using Select)");
  }
  return context;
};

export { SelectContext, useSelectContext };
//# sourceMappingURL=SelectContext.es.js.map
